import { FEATURE_ACCESS, FeatureAccess, ModuleAccess, ModuleAccessInput } from './access-types';

/**
 * BAO teachers need a BAOLL license on the super-module or the module for group management:
 * - without it, sharing, assignments and results are hidden
 * - with it, assignments are allowed, it replaces the digital manual license
 * BAOLL is a teacher license, students and material management follow the default rules.
 */
export function withBaoRules(access: ModuleAccess, { module, superModule, identity }: ModuleAccessInput): ModuleAccess {
  const hasBaollLicense = Boolean(superModule?.licenses.hasBaollLicense || module?.licenses.hasBaollLicense);

  function getAssignmentsAccess(): FeatureAccess {
    if (!identity.isTeacherAlike) return access.assignmentsAccess;
    if (access.assignmentsAccess === FEATURE_ACCESS.HIDDEN) return FEATURE_ACCESS.HIDDEN;

    return hasBaollLicense ? FEATURE_ACCESS.ALLOWED : FEATURE_ACCESS.HIDDEN;
  }

  function getResultsAccess(): FeatureAccess {
    return hasBaollLicense ? access.resultsAccess : FEATURE_ACCESS.HIDDEN;
  }

  return {
    ...access,
    assignmentsAccess: getAssignmentsAccess(),
    resultsAccess: getResultsAccess(),
    canShare: access.canShare && hasBaollLicense,
  };
}
